module.exports = __webpack_public_path__ + "static/media/towers.b9c935e2.png";